import isoCountries from 'i18n-iso-countries'
import enLocale from 'i18n-iso-countries/langs/en.json'

isoCountries.registerLocale(enLocale)

// Bullhorn is inconsistent about what it stores in a country field: it can be a picklist id ("2273"),
// an ISO alpha-2/alpha-3 code ("US", "PHL"), or the name itself ("United States"). Resolve all three
// to a name, and fall back to the raw value rather than rendering nothing.
const ISO_ALIASES = { UK: 'GB', EL: 'GR' }

export const resolveCountryLabel = (value, optionLists = []) => {
	if (!value) return null

	const rawValue = String(value).trim()
	if (!rawValue) return null

	const option = optionLists
		.filter(Boolean)
		.flat()
		.find(({ value: optionValue }) => String(optionValue) === rawValue)
	if (option?.label) return option.label

	// Only alphabetic values can be ISO codes. A numeric value is a Bullhorn picklist id, and i18n-iso-countries
	// would happily resolve it as a numeric ISO code ("840" -> United States), giving a confidently wrong name.
	if (/^[a-z]{2,3}$/i.test(rawValue)) {
		const isoCode = ISO_ALIASES[rawValue.toUpperCase()] || rawValue.toUpperCase()
		const isoName = isoCountries.getName(isoCode, 'en', { select: 'official' })
		if (isoName) return isoName
	}

	return rawValue
}

export const resolveCountryLabels = (values, optionLists = []) => {
	const list = Array.isArray(values) ? values : [values]

	return list.map((value) => resolveCountryLabel(value, optionLists)).filter(Boolean)
}
